import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { Confirm } from "../../Confirmation/Confirm";
import { Data, DocUpload } from "./AddContra.config";
import "./AddContra.scss";

import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { isEmpty } from "../../../../CommonFunction/GetUserInfo";
import { IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import TransactionCheck from "../../../../CommonFunction/TransactionCheck";
import {
  Audit_JournalVoucher_MUTATION,
  CreateVoucher,
  DELETE_Voucher_MUTATION,
  Edit_Voucher_Que,
  LOCK_VOUCHER,
  transactionData,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";

import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import { useModalContext } from "../../Reactportal/ModalContext";
import AddJournalVoucherSection, {
  makeTransactionObj,
} from "../AddJournalVoucher/AddJournalVoucherSection/AddJournalVoucherSection";
const AddContra = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction, setOpen }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Contra Voucher");
  const [isFirstLoad, setFirstLoad] = useState(false);
  const { pushModal, popModal } = useModalContext();
  const Form_Key = "Contra_Voucher";
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const BookingkeyName = useSelector((store) => store?.BookingBrokerVoucherData?.currentKey);
  const fielddata = fielddataRedux?.Contra_Voucher?.Selected_Row || fielddataRedux?.Account_Vouchers?.Selected_Row || fielddataRedux?.Transaction_Checks?.Selected_Row;
  const [GetTransactionData, { loading: GetTransactionDataLoader }] = useLazyQuery(transactionData, {
    fetchPolicy: "network-only",
  });

  const [lockJournalVoucher, { loading: lockJournalVoucherLoading }] = useMutation(LOCK_VOUCHER);
  let formRef = useRef({});

  const [TrasactionData, setTrasactionData] = useState([]);

  const [toggle, settoggle] = useState(show);
  const [alldata, setalldata] = useState({});
  const [allFieldsData, setAllFieldsData] = useState();
  const [notedata, setNotesdata] = useState();
  const [fileData, setFileData] = useState({});
  const [render, setRender] = useState(false);
  const tableData = useSelector((store) => store.TableDataReducer.tableData);
  const [deleteContraVoucher, { loading: deleteContraVoucherLoading }] = useMutation(DELETE_Voucher_MUTATION);
  const [data, setData] = useState();
  const [AuditContraVoucher, { loading: AuditContraVoucherLoading }] = useMutation(Audit_JournalVoucher_MUTATION);
  const [transactions, setTransactions] = useState([]);
  const FormData = useSelector((store) => store.FormFieldData);
  const [CreateJurnal, { loading: CreateJurnalLoading }] = useMutation(CreateVoucher);
  const [Edit_Jv, { loading: Edit_JvLoading }] = useMutation(Edit_Voucher_Que);
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });

  const ContraVoucherLoadingState =
    deleteContraVoucherLoading ||
    AuditContraVoucherLoading ||
    CreateJurnalLoading ||
    Edit_JvLoading ||
    lockJournalVoucherLoading ||
    GetTransactionDataLoader;

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (
      !isEmpty(fielddata) &&
      TypeOfPortal !== "Add" &&
      TypeOfPortal !== "Delete" &&
      (fielddata["_id"] || fielddata["id"] || fielddata["Voucher_Id"])
    ) {
      GetTransactionData({
        variables: {
          id: fielddata && TypeOfPortal !== "Add" ? fielddata["Voucher_Id"] || fielddata["_id"] || fielddata["id"] : "",
        },
      })
        .then((res) => {
          setData(res?.data);
          let JVData = { ...res?.data?.GetVoucherEntriesWithTransactions[0] };
          if (JVData.Date) {
            JVData.Date = IsoToDateWithoutTime(JVData.Date);
          }
          if (JVData.Doc_Date) {
            JVData.Doc_Date = IsoToDateWithoutTime(JVData.Doc_Date);
          }
          setNotesdata(JVData.Narration);
          setAllFieldsData(JVData);
          setRender(!render);
        })
        .catch((err) => console.log(err?.message));
    } else {
      setAllFieldsData({ Date: GetTodaysDateINdmy() });
      setNotesdata("");
    }
  }, [fielddata, modifiedTypeOfPortal]);

  useEffect(() => {
    if (TypeOfPortal === "Add") {
      let AccountData = FormDataFromRedux?.MasterData?.Booking_Broker?.Transporter_Account;
      let key = `Account_Name${Math.random() * 10}`;

      if (AccountData) {
        let obj = { ...makeTransactionObj() };
        // obj.id = AccountData?.Business_Name;
        let key = `Account_Name${Math.random() * 10}`;
        obj = {
          ...obj,
          [key]: AccountData?.Business_Name,
          name: key,
          Account_ID: AccountData?.Account_Balance_Id,
          Transaction_Type: "Debit",
        };
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              [key]: {
                ...AccountData,
                _id: AccountData?.Account_Balance_Id,
                AccountData: { Balance_Method: AccountData?.Balance_Method },
                Balance_Method: AccountData?.Balance_Method,
              },
            },
          },
        });
        let tData = [{ ...obj }, { ...makeTransactionObj() }];
        setTrasactionData(tData);
      }
    }
  }, [FormDataFromRedux?.MasterData?.Booking_Broker]);

  useEffect(() => {
    // debugger;
    if (data && data.GetVoucherEntriesWithTransactions && data.GetVoucherEntriesWithTransactions[0]) {
      let tr = data.GetVoucherEntriesWithTransactions[0].Transactions;
      let AllTransactions = tr?.map((el) => {
        let { Account } = el;
        let { AccountData } = Account;
        let name;
        if (AccountData && AccountData.Business_Name) {
          name = AccountData.Business_Name;
        } else if (AccountData && AccountData.Proprietor_Name) {
          name = AccountData.Proprietor_Name;
        } else if (AccountData && AccountData.BankAccount_Name) {
          name = AccountData.BankAccount_Name;
        } else if (AccountData && AccountData.Name) {
          name = AccountData.Name;
        } else if (AccountData && AccountData.Alternate_Name) {
          name = AccountData.Alternate_Name;
        }

        let key = `Account_Name${Math.random() * 10}`;
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              [key]: {
                Account_Balance_Id: el.Account_ID,
                _id: el.Account_ID,
                AccountData: { Balance_Method: AccountData?.Balance_Method },
                Balance_Method: AccountData?.Balance_Method,
              },
            },
          },
        });
        return {
          Account_ID: el.Account_ID,
          Transaction_Type: el.Transaction_Type,
          Amount: el.Amount,
          id: el._id,
          [key]: name,
          name: key,
          masterName: "All_Accounts",
        };
      });

      setTrasactionData(AllTransactions);
    }
  }, [data, render]);

  const changeDisable = (state) => {
    setDisable(state);
  };

  useEffect(() => {
    if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
      setalldata(FormDataFromRedux[Form_Key]);
    }
  }, [FormDataFromRedux]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Contra_Voucher?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const transactionChange = (t) => {
    if (t) {
      setTransactions(t);
    }
  };
  formRef.current.GetFileValues = (values) => {
    setFileData((prev) => {
      return { ...prev, ...values };
    });
  };
  const submit = async (close) => {
    let data = {};
    if (alldata.Doc_Details) {
      for (let key in alldata) {
        data = {
          ...data,
          ...alldata[key],
        };
      }
      // return
      data = {
        ...data,
        Narration: notedata,
        Date: data?.Date || "",
        Entry_Type: "Contra Voucher",
        Voucher_Type: "Contra Transcation",
        // Doc_Date: data.Doc_Date ? convertToISO(data.Doc_Date) : "",
        ...fileData,
      };
    }

    let Mutation =
      TypeOfPortal === "Add" || TypeOfPortal === "Copy"
        ? CreateJurnal
        : TypeOfPortal === "Edit"
          ? Edit_Jv
          : TypeOfPortal === "Delete"
            ? deleteContraVoucher
            : TypeOfPortal === "Lock" || TypeOfPortal === "Unlock"
              ? lockJournalVoucher
              : "";
    TransactionCheck(
      transactions,
      TypeOfPortal,
      Closeformfunction,
      setTrasactionData,
      settoggle,
      toggle,
      setNotesdata,
      setAllFieldsData,
      close,
      data,
      allFieldsData,
      Mutation,
      selectedRows,
      dispatch,
      tableData,
      FormDataFromRedux,
      Form_Key,
      BookingkeyName
    );
  };
  const SaveAndClose = () => {
    submit();
    // Closeformfunction();
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
    // Closeformfunction();
  };
  const Closeformfunction = useCallback(() => {
    ParentPortalCloseFunction();
    settoggle(false);
    setTrasactionData([]);
    setAllFieldsData({});
    dispatch({ type: "CleartableData", payload: { Madhu: "madjisa" } });
    dispatch({ type: "ClearData", payload: { data: {} } });
    ClearSpecificForm(dispatch, Form_Key);
    // dispatch({ type: "Refetch", payload: true });

    if (setOpen) {
      setOpen(false);
    }
  }, []);


  if (modifiedTypeOfPortal === "Delete Contra Voucher" || TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm toggle={toggle} settoggle={settoggle} submit={submit} loadingState={ContraVoucherLoadingState} />
      </>
    );
  }

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={ContraVoucherLoadingState}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={BookingkeyName ? "" : submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : SaveAndClose}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={ContraVoucherLoadingState}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
    />
  );

  return (
    <div>
      {" "}
      <div
        style={{
          display: id ? "none" : "block",
        }}
        onClick={() => {
          settoggle(!toggle);
        }}
      ></div>
      <Reactportal
        FoooterContent={footerContent}
        open={toggle}
        onClose={() => {
          Closeformfunction();
        }}
        TypeOfPortal={modifiedTypeOfPortal}
        id={allFieldsData && allFieldsData.Unique_Id ? allFieldsData.Unique_Id : id}
      >
        {ContraVoucherLoadingState && <div className="loader-line-div" />}
        <div className="journalMainContainer">
          <div className="journalContainer">
            {Data?.map((e) => {
              return (
                <>
                  <AddJournalVoucherSection
                    TrasactionData={TrasactionData}
                    inputfields={e.fields}
                    Type={e.name}
                    fielddata={allFieldsData}
                    TypeOfPortal={modifiedTypeOfPortal}
                    name={e.name}
                    transactionChange={transactionChange}
                    changeDisable={changeDisable}
                    title={"Contra Transcation"}
                    Form_Key={Form_Key}
                    setFirstLoad={setFirstLoad}
                  />
                </>
              );
            })}

            <div className="NoteImageHeading">
              <div>
                <p className="NoteLable">Notes: </p>
              </div>
              <div>
                <p className="NoteLable">Documents: </p>
              </div>
            </div>
            <div className="JournalVoucherNotesImages">
              <div className="NoteAndImages">
                <div className="moredetailsection">
                  <textarea
                    value={notedata}
                    name="note"
                    placeholder="Narration"
                    onChange={(e) => setNotesdata(e.target.value)}
                  ></textarea>
                </div>

                <div className="loadImages">
                  <DocumentuploadSection
                    data={DocUpload.fields}
                    TypeOfPortal={modifiedTypeOfPortal}
                    LoadForm={true}
                    formkey={Form_Key}
                    values={allFieldsData}
                    formReference={formRef}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default React.memo(AddContra);
